import React from "react";

const FujairahFaq = ({ title, faqs }) => {
  return (
    <section className="ft-faq-section">
      <div className="container">
        <h2
          className="text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <div
          className="ft-faq-list"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          {faqs.map((faq, i) => (
            <div key={i} className="ft-faq-item">
              <p className="ft-faq-question">Q: {faq.q}</p>
              <p className="ft-faq-answer">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FujairahFaq;
